export default {
    nextBtnText: "Weiter",
    prevBtnText: "Zurück",
    doneBtnText: "Schließen",
    steps: [
        {
            popover: {
                title: "Buchungswechsel",
                popoverClass: "quick-tour",
                description: `Hiermit haben Sie die Möglichkeit, <strong>innerhalb Ihrer momentanen Sitzung</strong>
            zu einer anderen Buchung zu wechseln bzw. für einen anderen Kunden zu handeln.`,
            },
            element: "#agency-nav",
        },
    ],
};
